/**
 * ToS and user data will be moved to version 3!
 */

function EmailReminder() {
    return (
        <div>
            <h1>Email Reminder Feature Coming Soon!</h1>
            <p>Return to the <a href="/">Home Page here...</a></p>
        </div>
    );
}

export default EmailReminder;